'use client';

import { Card } from '@/shared/ui/core';
import cn from 'classnames';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { XIcon } from '@phosphor-icons/react/dist/ssr';
import { ComponentPropsWithoutRef, ComponentRef, forwardRef, HTMLAttributes } from 'react';
import styles from './dialog.module.scss';


export const Dialog        = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;


export const DialogContent = forwardRef<
    ComponentRef<typeof DialogPrimitive.Content>,
    ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & { hideBackground?: boolean }
>(function DialogContent ({
    className, children, hideBackground, ...props
}, ref) {
    return (
        <DialogPrimitive.Portal>
            <DialogOverlay/>

            <DialogPrimitive.Content
                ref={ ref }
                className={ cn(styles.content, { [styles.no_background]: hideBackground }, className) }
                { ...props }
            >
                { children }
            </DialogPrimitive.Content>
        </DialogPrimitive.Portal>
    );
});


export function DialogHeader ({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <Card
            className={ cn(styles.header, className) }
            { ...props }
        >
            { children }

            <DialogPrimitive.Close className={ styles.close }>
                <XIcon size={ 20 }/>
                <span className={ styles.sr_only }>
                    Close
                </span>
            </DialogPrimitive.Close>
        </Card>
    );
}


export const DialogTitle = forwardRef<
    ComponentRef<typeof DialogPrimitive.Title>,
    ComponentPropsWithoutRef<typeof DialogPrimitive.Title>
>(function DialogTitle ({ className, ...props }, ref) {
    return (
        <DialogPrimitive.Title
            ref={ ref }
            className={ cn(styles.title, className) }
            { ...props }
        />
    );
});


export const DialogDescription = forwardRef<
    ComponentRef<typeof DialogPrimitive.Description>,
    ComponentPropsWithoutRef<typeof DialogPrimitive.Description>
>(function DialogDescription ({ className, ...props }, ref) {
    return (
        <DialogPrimitive.Description
            ref={ ref }
            className={ cn(styles.description, className) }
            { ...props }
        />
    );
});


export function DialogBody ({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <Card
            className={ cn(styles.body, className) }
            { ...props }
        >
            <div className={ styles.scroll }>
                { children }
            </div>
        </Card>
    );
}

const DialogOverlay = forwardRef<
    ComponentRef<typeof DialogPrimitive.Overlay>,
    ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(function DialogOverlay (props, ref) {
    return (
        <DialogPrimitive.Overlay
            ref={ ref }
            className={ styles.overlay }
            { ...props }
        />
    );
});
